// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {DataGridPro} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {Stack, Tooltip} from "@mui/material";
import Typography from "@mui/material/Typography";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ReorderIcon from '@mui/icons-material/Reorder';

// App Imports
import {
    deleteCSF,
    getContractSectionCSF, updateSectionFilterHierarchy
} from "../../ContractSectionFilter/ContractSectionFilterClient";
import {changeContractSectionFilter} from "../../ContractSectionFilter/contractSectionFilterSlice";
import ContractSectionFilterDrawer from "../../ContractSectionFilter/ContractSectionFilterDrawer";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import CdpInfoDialogue from "../ContractDrilldownCDP/Info/CdpInfoDialogue";
import CsfInfoDialogue from "./Info/CsfInfoDialogue";


// main function
export default function ContractDrilldownCSFGrid(props) {


    // ****************** BEGIN STATES ****************************

    const [drilldownCSF, setDrilldownCSF] = useState([]);
    const [allCSFs, setAllCSFs] = useState([]);
    const [filteredCSF, setFilteredCSF] = useState([]);
    const [csfInfoOpen, setCsfInfoOpen] = useState(false);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorContractSectionId = useSelector((state) => state.contractSectionSlc.value.id);
    const selectorCsfId = useSelector((state) => state.contractSectionFilterSlc.value.id);
    const selectorCsfHierarchy = useSelector((state) => state.contractSectionFilterSlc.value.hierarchy);

    const selectorContractGridAPI = useSelector((state) => state.contractSlc.value.contractGridAPI);
    const selectorCsfGridRefresh = useSelector((state) => state.contractSectionFilterSlc.value.csfGridRefresh);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    const hideActions = localStorage.getItem('hideActions') === "true";


    // ****************** BEGIN FETCH ****************************

    const fetchDrilldownCSF = React.useCallback(() => {
        if (!selectorContractSectionId) return Promise.resolve();

        return getContractSectionCSF(selectorContractSectionId)

            .then(data => {
                console.log("fetchDrilldownCSF");
                console.log(data);
                setDrilldownCSF(data);
                setAllCSFs(data);
                setFilteredCSF(data);
            });
    }, [selectorContractSectionId]);

    useEffect(() => {
        console.log("My CSF is so far...");
        fetchDrilldownCSF();
    }, [fetchDrilldownCSF]);


    useEffect(() => {
        if (!selectorCsfGridRefresh) return;

        console.log("fetching drilldown CSF has been triggered");

        fetchDrilldownCSF().finally(() => {
            dispatchData(changeContractSectionFilter({ csfGridRefresh: false }));
        });
    }, [selectorCsfGridRefresh, fetchDrilldownCSF, dispatchData]);

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

//     useEffect(() => {
//         console.log("My CSF is so far...");
//         fetchDrilldownCSF();
//     }, [useSelector((state) => state.contractSectionSlc.value.id)]);
//
//
//     useEffect(() => {
//         if (selectorCsfGridRefresh=== false) return;
//         console.log("fetching drilldown CSF has been triggered");
//         fetchDrilldownCSF();
//
//     dispatchData(changeContractSectionFilter({csfGridRefresh: false}));
// }, [useSelector((state) => state.contractSectionFilterSlc.value.csfGridRefresh)===true]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    const handleAdd = () => {
        dispatchData(changeContractSectionFilter({id: 0, mcode: "", name: "", description: "",
     contractSectionId: Number(selectorContractSectionId), parentFilterId: null, previousFilterId: null,
        accessType: null,  filteringMethod: null, dataPointId: null,
            singleValue: null, fromValue: null, toValue: null,dataType: null,
           csfDrawerState: true, csfDrawerMode: "Add"}));
    };

    const handleReorder = () => {
        if(filteredCSF.length === 0) return;
        updateSectionFilterHierarchy(selectorContractSectionId)
            .then(() => {
                dispatchData(changeContractSectionFilter({csfGridRefresh: true}))  ;
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Filters reordered"}));
                console.log("csf were reordered");})
.catch(err => {
        console.log(err)
        dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Reorder failed"}));
    })
};


    const handleCsfInfo = () => {
        setCsfInfoOpen(true);
    };

    const handleCloseCsfInfo = () => {
        setCsfInfoOpen(false);
    };

    // *************** END CONTROLS *******************************


    // ****************** BEGIN MENU ****************************

    function CsfGridCrudMenu() {

        const [anchorEl, setAnchorEl] = React.useState(null);

        const isMenuOpen = Boolean(anchorEl);

        const handleCrudMenuOpen = (event) => {
            // dispatchData(changeContractSection({id: rowId}));
            setAnchorEl(event.currentTarget);
        };

        function handleMenuClose()  {
            setAnchorEl(null);
        };

        const handleEdit = () => {
            dispatchData(changeContractSectionFilter({
                csfDrawerState: true, csfDrawerMode: "Edit"}));
        }


        const handleDelete = () => {
            console.log("Delete clicked");
            console.log("csId: ", selectorContractSectionId);
            console.log("csfId: ", selectorCsfId);
            console.log("Hierarchy: ", selectorCsfHierarchy);
            deleteCSF(selectorContractSectionId,selectorCsfId,  selectorCsfHierarchy)
                .then(() => {
                    updateSectionFilterHierarchy(selectorContractSectionId)
        .then(() => {
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
            dispatchData(changeContractSectionFilter({id: 0, contractSectionId:null, parentFilterId: null, previousFilterId: null, ordinalNumber: null, recordLevel: null,accessType:false,
                filteringMethod: null, dataPointId: null, singleValue: null, fromValue: null, toValue: null,
                status: null, hierarchy: null, createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                               csfDrawerState: false, csfGridRefresh: true}))  ;
            console.log("delete should trigger fetching drilldown CSF");})
        })
                .catch(err => {
                    console.log(err)
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Deletion failed"}));
                })
        };

        const handleMoveIn = () => {

        };

        const handleMoveOut = () => {

        };



        const crudId = 'primary-search-account-menu';

    const renderMenu = (

        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={crudId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}>
            <MenuItem
                onClick={handleEdit}>
                <ListItemIcon>
                    <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Edit</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleDelete}>
                <ListItemIcon>
                    <DeleteOutlineIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Delete</ListItemText>
            </MenuItem>
        </Menu>
    );


        return (
            <div>

                <IconButton
                    size="large"
                    edge="end"
                    aria-label="account of current user"
                    aria-controls={crudId}
                    aria-haspopup="true"
                    onClick={handleCrudMenuOpen}
                    color="inherit"
                >
                    <MoreVertIcon  color="primary" fontSize="small"/>
                </IconButton>
                {renderMenu}
            </div>
        );
    }
    // ****************** END MENU ****************************


    // ***************** BEGIN COLUMNS ***************************

    const columns = fetchDrilldownCSF => [

    {
        field: "cSFExplore",
        headerName: '',
        width: 60,
        padding: 0,
        margin: 0,
        sortable: false,
        menu: false,
        filter: false,
        renderCell: (filteredCSF) =>{
            return(
                <div                onMouseOver={()=> dispatchData(changeContractSectionFilter({
                    id: filteredCSF.row.id,
                    contractSectionId: filteredCSF.row.contractSectionId,
                    parentFilterId: filteredCSF.row.parentFilterId,
                    previousFilterId: filteredCSF.row.previousFilterId,
                    ordinalNumber: filteredCSF.row.ordinalNumber,
                    recordLevel: filteredCSF.row.recordLevel,
                    accessType: filteredCSF.row.accessType,
                    filteringMethod: filteredCSF.row.filteringMethod,
                    dataPointId: filteredCSF.row.dataPointId,
                    singleValue: filteredCSF.row.singleValue,
                    fromValue: filteredCSF.row.fromValue,
                    toValue: filteredCSF.row.toValue,
                    status: filteredCSF.row.status,
                    hierarchy: filteredCSF.row.hierarchy,
                    createdOn: filteredCSF.row.createdOn,
                    createdBy: filteredCSF.row.createdBy,
                    lastModifiedOn: filteredCSF.row.lastModifiedOn,
                    lastModifiedBy: filteredCSF.row.lastModifiedBy,
                    mockValue: filteredCSF.row.mockValue,
                    contractId: filteredCSF.row.contractId,
                    dataPointName: filteredCSF.row.dataPointName,
                    dataType: filteredCSF.row.dataType,
                    displaySingleValue: filteredCSF.row.displaySingleValue,
                    displayFromValue: filteredCSF.row.displayFromValue,
                    displayToValue: filteredCSF.row.displayToValue,
                    parentDataPointId: filteredCSF.row.parentDataPointId,
                    parentDataPointName: filteredCSF.row.parentDataPointName,
                    parentDataType: filteredCSF.row.parentDataType,
                    parentDisplaySingleValue: filteredCSF.row.parentDisplaySingleValue,
                    parentDisplayFromValue: filteredCSF.row.parentDisplayFromValue,
                    parentDisplayToValue: filteredCSF.row.parentDisplayToValue

                }))
                }>
                    {!hideActions &&
            <CsfGridCrudMenu/>
                    }
                    </div>
)
}
    },

    {
        field: 'contractSectionId',
        headerName: 'cs',
        renderCell: (filteredCSF) => {
            return <div className="rowitem">{filteredCSF.row.contractSectionId}</div>;},
        // return <div className="rowitem">{filteredCSF.row.contractSectionId.id}</div>;},
        description: '',
        sortable: true,
        // editable: true,
        width: 30,
        hide: true,
    },
    {    field: 'id',
        headerName: 'ID',
        description: '',
        sortable: false,
        width: 60,
        hide: true,
    },
    {
        field: 'accessType',
        headerName: 'Access',
        description: '',
        sortable: false,
        // editable: true,
        width: 60,
    },
    {
        field: 'filteringMethod',
        headerName: 'Filtering',
        description: '',
        sortable: false,
        width: 120,

    },
    {
        field: 'recordLevel',
        headerName: 'Level',
        description: '',
        sortable: false,
        hide: true,
        width: 60,

    },
    {
        field: 'parentFilterId',
        headerName: 'Parent',
        description: '',
        sortable: false,
        hide: true,
        width: 80,

    },
    {
        field: 'dataPointId',
        headerName: 'dp.id',
        description: '',
        sortable: false,
        width: 80,
        hide: true,
    },
    {
        field: 'dataPointName',
        headerName: 'Name',
        renderCell: (filteredCSF) => {
            return                     <Tooltip enterDelay={1000} enterNextDelay={1000} title={<span style={{whiteSpace: 'pre-line'}}>
                            {"id: " + filteredCSF.row.id +
                                "\nparent: " + filteredCSF.row.parentFilterId +
                                "\nprevious: " + filteredCSF.row.previousFilterId +
                                "\ndata point id: " + filteredCSF.row.dataPointId +
                                "\ndata point name: " + filteredCSF.row.dataPointName +
                                "\nlevel: " + filteredCSF.row.recordLevel
                            }  </span>} style={{cursor:'pointer'}} ><div className="rowitem2">{filteredCSF.row.dataPointName}</div></Tooltip>;},
        description: '',
        sortable: false,
        width: 230,
    },
    {
        field: 'mockValue',
        headerName: 'Single Value',
        renderCell: (filteredCSF) => {
            return                     <Tooltip enterDelay={1000} enterNextDelay={1000} title={filteredCSF.row.displaySingleValue} style={{cursor:'pointer'}} ><div className="rowitem2">{filteredCSF.row.displaySingleValue}</div></Tooltip>;},

        description: '',
        sortable: false,
        width: 200,
        // // TODO: get this field to render correctly for dpv names
    },
    //     // // TODO: get this field to render correctly for dpv names
    // },
    {
        field: 'displayFromValue',
        headerName: 'From',
        description: '',
        sortable: false,
        width: 100,
    },
    {
        field: 'displayToValue',
        headerName: 'To',
        description: '',
        sortable: false,
        width: 100,
    },
        {
            field: 'dataType',
            headerName: 'Data Type',
            description: '',
            sortable: false,
            hide: true,
            width: 100,
        },
];

    // *************** END COLUMNS *******************************


    const getTreeDataPath = (filteredCSF) => filteredCSF.hierarchy.split(',');

    const groupingColDef = {
        hideDescendantCount: true,
    };


    // ****************** BEGIN RETURN ****************************

    return (

        <Box sx={{ height: '100%', width: '100%',
            '& .level--1': {backgroundColor: "rgb(30,144,255)"},//https://html-color.codes/blue dodger blue
            '& .level--2': {backgroundColor: "rgb(69,177,232)"},//https://html-color.codes/blue picton blue
            '& .level--3': {backgroundColor: "rgb(135,206,250)"},//https://html-color.codes/blue lightskyblue
            '& .level--4': {backgroundColor: "rgb(137,207,240)"},//https://html-color.codes/blue baby blue
            '& .level--5': {backgroundColor: "rgb(173,216,230)"},//https://html-color.codes/blue light blue
            '& .level--6': {backgroundColor: "rgb(135,206,235)"},//https://html-color.codes/blue skyblue
            '& .level--7': {backgroundColor: "rgb(231,254,255)"},//https://html-color.codes/blue bubbles
            '& .level--8': {backgroundColor: "rgb(244,240,236)"},//https://html-color.codes/grey isabelline
            '& .level--9': {backgroundColor: "rgb(250,250,250)"},//custom
            '& .level--10': {backgroundColor: "rgb(255,255,255)"},//custom
            }}>
            {useSelector((state) => state.contractSectionFilterSlc.value.csfDrawerState) &&
                <ContractSectionFilterDrawer
                />}
            <Stack direction="row" spacing={2}>
                <Box>
                    {selectorContractGridAPI !== "Dashboards" &&
                    <Tooltip enterDelay={1000} title={"Data points that grant or deny access to this contract section.  Click for more information."}>
                        <Typography onClick={() => handleCsfInfo()}  style={{cursor:'pointer'}}  sx={{ fontWeight: 'bold',
                        htmlFontSize: 48
                    }} >Contract Section Filters</Typography>
                    </Tooltip>
                    }
                    {selectorContractGridAPI === "Dashboards" && <Typography sx={{ fontWeight: 'bold',
                        htmlFontSize: 48
                    }} >Filtering Criteria</Typography>}
                </Box>
                {!hideActions &&
                    <Tooltip enterDelay={1000} title="Add Contract Section Filter">
                <Box              sx={{alignItems: 'bottom',  pb: 0, mr: 3, mb: 0, verticalAlign: 'bottom'}}
                                  style={{cursor:'pointer'}}
                                  onClick={() => handleAdd()}>
                    <AddCircleOutlineIcon  sx={{my:0 }}  fontSize="medium" color={'primary'}
                    />
                </Box>
                    </Tooltip>
                    }
                <CsfInfoDialogue
                    open={csfInfoOpen}
                    onClose={handleCloseCsfInfo}
                    selectorContractGridAPI={selectorContractGridAPI}
                />
                {/*{!hideActions &&*/}
                {/*    <Tooltip enterDelay={1000} title="Reorder Contract Section Filters">*/}
                {/*    <Box              sx={{alignItems: 'bottom',  pb: 0, mr: 3, mb: 0, verticalAlign: 'bottom'}}*/}
                {/*                      style={{cursor:'pointer'}}*/}
                {/*                      onClick={() => handleReorder()}>*/}
                {/*        <ReorderIcon  sx={{my:0 }}  fontSize="medium" color={'primary'}*/}
                {/*        />*/}
                {/*    </Box>*/}
                {/*    </Tooltip>*/}
                {/*    }*/}
            </Stack>
            <DataGridPro
                treeData
                style={{ height: '100%' , width: '100%' }}
                aria-label={"ContractSectionFilters2"}
                rows={filteredCSF}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={columns(fetchDrilldownCSF)}
                getTreeDataPath={getTreeDataPath}
                groupingColDef={groupingColDef}
                getRowClassName={(filteredCSF) => `level--${filteredCSF.row.recordLevel}`}
                density={"compact"}
                pageSize={30}
                rowsPerPageOptions={[30]}
                hideFooter = {true}
            />
        </Box>


    );

    // ****************** END RETURN ****************************



}




